import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useRenameCalendar = ({ onSuccess }) => {
  const { onSubmit: handleRenameCalendar } = useFetch(
    'rename-calendar',
    Api.CALENDAR_RENAME
  );

  const onRenameCalendar = (id) => (name) =>
    handleRenameCalendar({
      method: 'PUT',
      pathParams: { id },
      queryParams: { name },
      onSuccess,
    });

  return {
    onRenameCalendar,
  };
};

export default useRenameCalendar;
